/**
 * Mode diagnostic du démarrage (01/10/2026).
 *
 * Depuis que les beacons atteignent l'API (#2570, #2572), chaque ouverture de
 * page envoyait une trentaine de jalons « tout va bien » (logs Railway du 30/09,
 * 21:47 : une visite iPhone = ~30 requêtes). Par défaut, seuls les PROBLÈMES
 * partent désormais (crash, erreur, stockage bloqué, page restée blanche).
 *
 * Pour suivre un démarrage pas à pas sur un appareil précis, ouvrir une fois
 * `https://www.gively.fr/?debug_boot=1` : le mode reste actif sur cet appareil
 * (`?debug_boot=0` le coupe). Même clé que le script inline de public/index.html.
 */
export const CLE_DEBUG_BOOT = "gively_debug_boot";

export function modeDiagnosticDemarrage() {
  try {
    const m = /[?&]debug_boot=([01])/.exec(window.location.search || "");
    if (m) {
      if (m[1] === "1") window.localStorage.setItem(CLE_DEBUG_BOOT, "1");
      else window.localStorage.removeItem(CLE_DEBUG_BOOT);
    }
    return window.localStorage.getItem(CLE_DEBUG_BOOT) === "1";
  } catch (_) {
    return false;
  }
}

export default modeDiagnosticDemarrage;
